import React, { FC } from 'react';

export const FacebookSmall: FC = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0398 2.22266H3.1842C2.77738 2.22568 2.44834 2.55473 2.44531 2.96155V14.8171C2.44834 15.2239 2.77738 15.553 3.1842 15.556H9.56753V10.4004H7.8342V8.38377H9.56753V6.90043C9.56753 5.17821 10.6175 4.23932 12.162 4.23932C12.6786 4.23932 13.1953 4.23932 13.712 4.3171V6.11154H12.6509C11.812 6.11154 11.6509 6.51155 11.6509 7.09488V8.37821H13.6509L13.3898 10.3949H11.6509V15.556H15.0398C15.4466 15.553 15.7756 15.2239 15.7786 14.8171V2.96155C15.7756 2.55473 15.4466 2.22568 15.0398 2.22266Z"
        fill="#000624"
      />
    </svg>
  );
};

export const InstagramSmall: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <circle cx="12.559" cy="5.33" r="0.8" fill="#000624"></circle>
      <path
        fill="#000624"
        fillRule="evenodd"
        d="M5.577 8.888a3.423 3.423 0 1 1 6.847 0 3.423 3.423 0 0 1-6.847 0m1.201 0a2.222 2.222 0 1 0 4.445 0 2.222 2.222 0 0 0-4.445 0"
        clipRule="evenodd"
      ></path>
      <path
        fill="#000624"
        fillRule="evenodd"
        d="M6.252 2.262c.711-.033.938-.04 2.749-.04 1.81 0 2.037.007 2.748.04.553.011 1.1.116 1.618.31a3.4 3.4 0 0 1 1.95 1.95c.194.518.3 1.065.31 1.618.033.71.04.938.04 2.748s-.007 2.038-.04 2.749a4.9 4.9 0 0 1-.31 1.618 3.4 3.4 0 0 1-1.95 1.95 4.9 4.9 0 0 1-1.618.31c-.71.032-.938.04-2.748.04s-2.038-.008-2.749-.04a4.9 4.9 0 0 1-1.618-.31 3.4 3.4 0 0 1-1.95-1.95 4.9 4.9 0 0 1-.31-1.618c-.032-.711-.04-.938-.04-2.749 0-1.81.008-2.037.04-2.748.011-.553.116-1.1.31-1.618a3.4 3.4 0 0 1 1.95-1.95 4.9 4.9 0 0 1 1.618-.31m5.443 1.2c-.703-.032-.914-.04-2.694-.04s-1.991.008-2.694.04a3.7 3.7 0 0 0-1.238.23 2.2 2.2 0 0 0-1.265 1.265 3.7 3.7 0 0 0-.23 1.238c-.032.702-.039.913-.039 2.693s.007 1.991.04 2.694c.004.423.082.842.229 1.238.224.582.683 1.041 1.265 1.265a3.7 3.7 0 0 0 1.238.23c.703.032.913.039 2.694.039s1.99-.007 2.694-.039a3.7 3.7 0 0 0 1.237-.23 2.2 2.2 0 0 0 1.266-1.265 3.7 3.7 0 0 0 .23-1.238c.031-.703.038-.914.038-2.694s-.007-1.99-.039-2.693a3.7 3.7 0 0 0-.23-1.238 2.2 2.2 0 0 0-1.264-1.266 3.7 3.7 0 0 0-1.239-.23"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export const LinkedInSmall: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        fill="#000624"
        fillRule="evenodd"
        d="M3.217 2.222h11.345a.99.99 0 0 1 .994.96v11.373a.983.983 0 0 1-.994.961H3.217a.983.983 0 0 1-.994-.961V3.183a.99.99 0 0 1 .994-.961m1 11.339h1.956V7.22H4.217zm1-7.223a1.15 1.15 0 0 1-1.15-1.122 1.11 1.11 0 0 1 1.15-1.15 1.15 1.15 0 0 1 0 2.294zm6.45 7.184H13.6V10.05c0-1.695-.372-3.028-2.366-3.028A2.07 2.07 0 0 0 9.35 8.055h-.038v-.833H7.467v6.267h1.978v-3.14c0-.816.155-1.627 1.189-1.627 1.033 0 1.033.961 1.033 1.7z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
